export default class OnboardService {
  constructor(userService, leanLawApi) {
    this.userService = userService;
    this.leanLawApi = leanLawApi;
  }
  reload() {
    this.message();
  }
  message() {
    if (!this.userService || typeof this.userService.me !== 'function') {
      return Promise.resolve({
        summary: null
      });
    }
    return this.userService.me().then(me => {
      const sub = me.company.subscription;
      const message = {};

      // Exclude non-customer accounts from trial messaging
      const accountStatus = me.company && me.company.status;
      if (['internal', 'test', 'demo'].includes(accountStatus)) {
        message.summary = null;
        return message;
      }

      // Don't show banner if not in trial period and no trial days remaining
      if (!sub.trial && (!sub.trialEndDays || sub.trialEndDays <= 0)) {
        message.summary = null;
        return message;
      }

      // Trial has expired
      if (sub.inactive || sub.trialExpired) {
        message.level = 'error';
        message.summary = 'Your trial has expired, click to subscribe.';
        message.isClickable = !!me.access.setup;
        message.sref = 'settings.company.maxioCompanySubscription';
        message.isExpired = true;
        return message;
      }

      // If trial is false but they still have trial days remaining, they've subscribed
      const hasSubscribed = !sub.trial && !sub.trialExpired && sub.trialEndDays > 0;
      if (hasSubscribed) {
        message.level = 'info';
        message.summary = `Trial ends in ${sub.trialEndDays} ${sub.trialEndDays === 1 ? 'day' : 'days'}. You're all set.`;
        message.isClickable = false; // No action needed - they're ready
      } else if (sub.trial) {
        message.level = 'warning';
        message.summary = `Pick a plan before your trial ends in ${sub.trialEndDays} ${sub.trialEndDays === 1 ? 'day' : 'days'}`;
        message.isClickable = !!me.access.setup;
        message.sref = 'settings.company.maxioCompanySubscription';
      } else {
        message.summary = null;
      }
      return message;
    });
  }
  days(d) {
    if (d === 0) return 'No days remain';
    if (d === 1) return 'One day remains';
    return `${Math.abs(d)} days remain`;
  }
}